import { Environment } from './enviroment.model';
import { defaultEnv } from './default-env';
export const environment = defaultEnv as Environment;



// WEBPACK FOOTER //
// ./src/environments/environment.ts